import React, { useState } from "react";
import { useTranslation } from "react-i18next";

function AccountInfo({ setIsShow, account }) {
  const { t } = useTranslation();
  const [isCopy, setIsCopy] = useState(false);

  const handleUrlCopy = () => {
    navigator.clipboard
      .writeText(account?.wabaNumber)
      .then(() => {
        setIsCopy(true);
        setTimeout(() => setIsCopy(false), 5000); // Reset after 2 seconds
      })
      .catch((error) => console.error("Copy failed", error));
  };
  return (
    <>
      <div className="flex gap-4 p-6">
        <div className="w-full rounded-lg bg-gray-100 p-4">
          <div className="text-[16px] font-semibold flex">
            {account.teamName ?? account?.whatsappDisplayName}
            <svg
              className="mt-1 ml-1"
              width="17"
              height="18"
              viewBox="0 0 17 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.95703 1.22715C8.12303 1.0571 8.3965 1.0571 8.56251 1.22715L9.40921 2.09452C9.53134 2.21963 9.71785 2.25673 9.87855 2.18788L10.9928 1.71055C11.2112 1.61697 11.4639 1.72162 11.5522 1.94226L12.0025 3.06763C12.0674 3.22995 12.2255 3.33559 12.4004 3.33349L13.6124 3.31887C13.85 3.31601 14.0434 3.50938 14.0405 3.74701L14.0259 4.95904C14.0238 5.13387 14.1295 5.29198 14.2918 5.35693L15.4171 5.80726C15.6378 5.89555 15.7424 6.1482 15.6489 6.36665L15.1715 7.48083C15.1027 7.64153 15.1398 7.82804 15.2649 7.95017L16.1323 8.79687C16.3023 8.96287 16.3023 9.23634 16.1323 9.40235L15.2649 10.249C15.1398 10.3712 15.1027 10.5577 15.1715 10.7184L15.6489 11.8326C15.7424 12.051 15.6378 12.3037 15.4172 12.392L14.2918 12.8423C14.1295 12.9072 14.0238 13.0653 14.0259 13.2402L14.0405 14.4522C14.0434 14.6898 13.85 14.8832 13.6124 14.8803L12.4004 14.8657C12.2255 14.8636 12.0674 14.9693 12.0025 15.1316L11.5522 16.2569C11.4639 16.4776 11.2112 16.5822 10.9928 16.4887L9.87855 16.0113C9.71785 15.9425 9.53134 15.9796 9.40921 16.1047L8.56251 16.9721C8.39651 17.1421 8.12304 17.1421 7.95703 16.9721L7.11033 16.1047C6.9882 15.9796 6.80169 15.9425 6.64099 16.0113L5.52681 16.4887C5.30836 16.5822 5.05571 16.4776 4.96742 16.257L4.51709 15.1316C4.45214 14.9693 4.29403 14.8636 4.1192 14.8657L2.90717 14.8803C2.66954 14.8832 2.47617 14.6898 2.47903 14.4522L2.49365 13.2402C2.49575 13.0653 2.39011 12.9072 2.22779 12.8423L1.10242 12.392C0.881778 12.3037 0.777125 12.051 0.87071 11.8326L1.34804 10.7184C1.41689 10.5577 1.37979 10.3712 1.25468 10.249L0.387308 9.40235C0.217252 9.23635 0.217251 8.96288 0.387308 8.79687L1.25468 7.95017C1.37979 7.82804 1.41689 7.64153 1.34804 7.48083L0.87071 6.36665C0.777125 6.1482 0.881778 5.89555 1.10242 5.80726L2.22779 5.35693C2.39011 5.29198 2.49575 5.13387 2.49365 4.95904L2.47903 3.74701C2.47617 3.50938 2.66954 3.31601 2.90717 3.31887L4.1192 3.33349C4.29403 3.33559 4.45214 3.22995 4.51709 3.06763L4.96742 1.94226C5.05571 1.72162 5.30836 1.61697 5.52681 1.71055L6.64099 2.18788C6.80169 2.25673 6.9882 2.21963 7.11033 2.09452L7.95703 1.22715Z"
                fill={
                  //account?.whatsappQualityRatings === "GREEN"
                  //? "#1AE969"
                  "blue"
                }
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.0755 6.53555C12.313 6.77305 12.313 7.15812 12.0755 7.39562L7.80917 11.6619C7.57167 11.8994 7.1866 11.8994 6.9491 11.6619L5.31583 10.0287C5.07832 9.79116 5.07832 9.40609 5.31583 9.16859C5.55333 8.93109 5.93839 8.93109 6.17589 9.16859L7.37914 10.3718L11.2154 6.53555C11.453 6.29805 11.838 6.29805 12.0755 6.53555Z"
                fill="white"
              />
            </svg>
          </div>
          <div className="text-[13px] text-gray-500 flex">
            <i className="fa-brands fa-whatsapp mt-1 mr-1"></i>{t('Connected with')}{" "}
            <span className="text-gray-600 font-semibold ml-1">
              {" "}
              {` +${account?.phoneCode} ${account?.phone}`}
            </span>
          </div>
          <div className="mt-2">
            <p className="text-gray-500 text-[14px]">{t('Business name')}</p>
            <p className="text-[14px]">{account?.whatsappDisplayName}</p>
          </div>
          <div className="mt-2">
            <p className="text-gray-500 text-[14px]">{t('WABA ID')}</p>
            <div className="flex">
              <p className="text-[14px]">{account?.wabaNumber}</p>
              <button type="button" onClick={handleUrlCopy}
                className="text-green-500 rounded-[4px] px-4"
              >{isCopy ? "Copied" : "Copy"}
              </button>
            </div>
          </div>
          {/* <div className='mt-2'>
                    <p className='text-gray-500 text-[14px]'>STATUS</p>
                    <label className='text-[14px] bg-[#D2FFF0] px-2 pb-1 rounded-[2px]'>Connected</label>
                </div> */}
          <div className="mt-2">
            <p className="text-gray-500 text-[14px]">{t('ACCOUNT STATUS')}</p>
            <label className="text-[14px] bg-[#D2FFF0] px-2 pb-1 rounded-[2px]">
              {account?.accountStatus}
            </label>
          </div>
          <div className="mt-2">
            <p className="text-gray-500 text-[14px]">{t('Message Limit')}</p>
            <label className="text-[14px] bg-[#D2FFF0] px-2 pb-1 rounded-[2px]">
              {account?.messagingLimit}
            </label>
          </div>
        </div>
        <div className="w-full rounded-lg bg-gray-100 p-4">
          <div className="text-[16px] font-semibold">{t('Facebook Business')}</div>
          <div className="mt-2">
            <p className="text-gray-500 text-[14px]">{t('Facebook Business name')}</p>
            <p className="text-[14px]">{account?.facebookBusinessName}</p>
          </div>
          <div className="mt-2">
            <p className="text-gray-500 text-[14px]">
              {t('FB business verification')}
            </p>
            <label className="text-[14px] bg-[#D2FFF0] px-2 pb-1 rounded-[2px]">
              {account?.whatsappVerificationStatus}
            </label>
          </div>
          <div className="mt-2">
            <p className="text-gray-500 text-[14px]">{t('Quality ratings')}</p>
            <label className="text-[14px]">
              {account?.whatsappQualityRatings}
            </label>
          </div>
          {/* <div className='mt-2'>
                    <p className='text-gray-500 text-[14px]'>THROUGHPUT</p>
                    <label className='text-[14px] bg-[#D2FFF0] px-2 pb-1 rounded-[2px]'>Standard</label>
                </div> */}
        </div>
      </div>
    </>
  );
}

export default AccountInfo;
